import React, { useRef } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { soundManager } from '../../utils/soundManager';

export const CURRENT_APP_VERSION = '1.5.6';

export const WelcomeScreen = ({
  starting,
  error,
  onStart,
  onMasterAccessTrigger,
}) => {
  const { t } = useLanguage();
  const longPressTimer = useRef(null);
  const pressStartTime = useRef(null);

  // Long press handlers for version text (Master access)
  const handleVersionPressStart = () => {
    pressStartTime.current = Date.now();
    longPressTimer.current = setTimeout(() => {
      // 4 seconds reached - trigger master access
      onMasterAccessTrigger();
      soundManager.playSparkle();
    }, 4000);
  };

  const handleVersionPressEnd = () => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
    pressStartTime.current = null;
  };

  return (
    <div className="fp-root" style={styles.content}>
      <div style={styles.fade} />
      <div style={styles.startContainer}>
        <div className="fp-rise" style={styles.titleBand}>
          <h1 className="fp-brand" style={styles.title}>FootParadise</h1>
          <span className="fp-chip fp-chip--pink" style={styles.tagline}>Comics</span>
        </div>
        <button
          onClick={onStart}
          disabled={starting}
          className="fp-btn fp-btn--gold fp-btn--lg fp-btn--shine fp-btn--pulse"
          style={styles.startButton}
          data-testid="start-button"
        >
          {starting ? t('loading') : t('start')}
        </button>
        {error && (
          <div style={styles.error}>
            {error}
          </div>
        )}
      </div>
      {/* Version Text - Long press for Master access */}
      <div 
        style={styles.versionContainer}
        onTouchStart={handleVersionPressStart}
        onTouchEnd={handleVersionPressEnd}
        onTouchCancel={handleVersionPressEnd}
        onMouseDown={handleVersionPressStart}
        onMouseUp={handleVersionPressEnd}
        onMouseLeave={handleVersionPressEnd}
        data-testid="version-text"
      >
        <span style={styles.versionText}>{t('version')} {CURRENT_APP_VERSION}</span>
      </div>
    </div>
  );
};

const styles = {
  content: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    margin: '0',
    padding: '0',
    backgroundImage: 'url(/start-background.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fade: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '46%',
    background: 'linear-gradient(180deg, rgba(27,10,51,0) 0%, rgba(27,10,51,0.6) 50%, rgba(20,6,31,0.92) 100%)',
    pointerEvents: 'none',
  },
  startContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '26px',
    width: '100%',
    position: 'absolute',
    top: '74%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  titleBand: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  title: {
    margin: 0,
    fontSize: '52px',
    lineHeight: 1,
    textAlign: 'center',
    transform: 'rotate(-3deg)',
  },
  tagline: {
    marginTop: '6px',
    fontSize: '14px',
    padding: '4px 18px',
    transform: 'rotate(-3deg)',
  },
  startButton: {
    minWidth: '200px',
    fontSize: '21px',
    letterSpacing: '2px',
  },
  versionContainer: {
    position: 'absolute',
    bottom: '24px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    padding: '6px 16px',
    borderRadius: '20px',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    transition: 'background-color 0.2s ease',
  },
  versionText: {
    fontSize: '11px',
    color: 'rgba(255, 255, 255, 0.85)',
    fontWeight: '500',
    letterSpacing: '0.5px',
  },
  error: {
    backgroundColor: '#fee',
    color: '#c33',
    padding: '12px',
    borderRadius: '8px',
    marginTop: '20px',
    fontSize: '14px',
  },
};

export default WelcomeScreen;
